import React from 'react';
import { Card } from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';
import {Link} from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const AziendaPerIniziare = () => {

  return (<>
    <PageHeader
      title="Per compilare il questionario"
      description=""
      className="mb-3"
    >
    </PageHeader>
    
    <Card style={{marginTop:"2%", marginBottom:"2%"}}>
        <Card.Body>
          <Card.Title>
            <h5 className="text-info fw-medium mb-0" style={{marginBottom:"3%"}}>I primi passi per l'azienda</h5>
          </Card.Title>
          <Card.Text>
          <p>Per compilare il questionario bisogna seguire le fasi del processo indicate nel Menù con richiamo alle istruzioni ed esemplificazioni di supporto.</p>

          <br/>
          <p>La compilazione del questionario avviene seguendo le quattro fasi del processo EFRAG riportate nel menù a sinistra:</p>
            <ul>
              <li>FASE A EFRAG - Selezione Stakeholder e ambiti</li>
              <li>FASE B EFRAG - Identificazione rischi / azioni e mitigazione con opportunità</li>
              <li>FASE C EFRAG - Valutazione rilevanza rischi e misurazione del valore condiviso per KPI</li>
              <li>QUARTA FASE: OUTPUT</li>
            </ul>
            <br/> 
            <h4 className="text-info fw-medium mb-0" style={{marginBottom:"3%"}}>COMPILAZIONE QUESTIONARIO</h4><br/> 
            <p>Cliccando sulle righe di Menù corrispondenti a ciascuna delle fasi sopra elencate, si aprirà una pagina che riepiloga un certo numero di schede nelle quali è descritta la metodologia.</p>
            
            <p><strong>È opportuno procedere con la lettura e lo studio della metodologia, riportata nelle schede, prima di procedere con la compilazione del questionario.</strong></p>

            <p>Sempre nel Menù di sinistra, sotto a ciascuna FASE, sono elencate le righe che aprono le pagine in cui inserire i dati. Per maggiore chiarezza ciascuna riga è completata dall'indicazione, tra parentesi, delle schede in cui è stata descritta la metodologia.</p>
            <br/> <hr/>
            <h5 className="text-info fw-medium mb-0" style={{marginBottom:"3%"}}>COMPILAZIONE DATI GENERALI INDIPENDENTI DALL'AMBITO</h5>
            <br/> 
            <ul>
              <li>Per la <strong>FASE A EFRAG</strong> input di:
                <ul>
                  <li>
                    Selezione aziendale stakeholder (SCHEDE 1 e 5)
                  </li>
                  <li>
                    Selezione aziendale ambiti (SCHEDE 2 e 6)
                  </li>
                  <li>
                    Inserimento analisi strategica dell'azienda per la sostenibilità (SCHEDA 3)
                  </li>
                </ul>
              </li><br></br>
              <li>Per la <strong>FASE B EFRAG</strong>, in un primo momento sarà necessario:
                <ul>
                  <li>
                    Identificare i periodi per la rilevazione (SCHEDA 7)
                  </li>
                </ul>
              </li>
            </ul>
            <br/>  <hr/>
            <h5 className="text-info fw-medium mb-0" style={{marginBottom:"3%"}}>COMPILAZIONE DATI DIPENDENTI DALL'AMBITO</h5>
            <br/> 
            <p>Dopo questi primi passaggi l'operatività si sposterà sulle schede previste per ciascun ambito.  <br /><br /><strong>Lavorando per ambito</strong>, si potrà:</p>
              <ul>
                <li>
                  Completare la <strong>FASE B EFRAG</strong> identificando rischi e mitigazioni (SCHEDE 8 e 9). 
                  <p className="fw-medium mb-0" style={{marginBottom:"3%"}}>L'identificazione di rischi e mitigazioni è facilitata da: <ul>
                    <li>la precompilazione di rischi ed azioni proposte di default dal sistema;</li>
                    <li>le esemplificazioni riportate come suggerimenti nelle pagine degli ambiti.</li>
                    </ul>
                    I rischi e le azioni sono comunque modificabili cliccando sul pulsante <strong>[ Ridefinisci il rischio ]</strong> a fianco di ciascun rischio proposto di default.</p><br />
                </li>
                <li>
                  Passare alla <strong>FASE C EFRAG</strong> valutando la rilevanza dei rischi sopra identificati e definendo le azioni di mitigazione da implementare (SCHEDE 10, 11 e 12).
                </li>
              </ul>
              <br/> <hr/>
              <h5 className="text-info fw-medium mb-0" style={{marginBottom:"3%"}}>QUARTA FASE: OUTPUT</h5><br />
              <p>Per la QUARTA FASE OUTPUT, sarà necessario fornire un ultimo INPUT di carattere generale:</p>
            <ul>
              <li>
                Il conto economico dell'azienda (SCHEDE 14 e 16). 
              </li>
            </ul>

            <br />
            <h5>I tre output forniti dal sistema:</h5><br />
            <ul>
              <li>
                La doppia matrice di materialità  (SCHEDE 13 e 15)
              </li>
              <li>
                Il valore aggiunto riattribuito (VARA) (SCHEDE 14 e 16)
              </li>
              <li>
                Il riepilogo dei dati in input  (Schema di output coerente con quello della SCHEDA 12 utilizzato per l'input)
              </li>
            </ul>
            <hr/>
          </Card.Text>
          <Card.Footer>
              <Link to="/app/welcome/presentazione">
                <FontAwesomeIcon icon="chevron-left" className="ms-1 fs-11" />&nbsp;&nbsp;&nbsp;
                Vai alla Presentazione 
              </Link>
           </Card.Footer>
        </Card.Body>
      </Card>

    </>)
};

export default AziendaPerIniziare;
